import { APICall } from "@/config/NetworkUtility";
import { callLoader } from "@/redux/Loader/actions";
import { CUSTOMER_COMPANY_LIST, CUSTOMER_LIST, CUSTOMER_PAGINATION } from "./constant";

export const getCustomerList = (payload) => {
    return async (dispatch) => {
        try {
            const queryParams = new URLSearchParams(payload).toString();
            const url = `v1/CustomerProfile/GetUserList?${queryParams}`;

            const result = await APICall("get", payload, url);

            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CUSTOMER_LIST,
                    payload: result?.data || [],
                });

                dispatch({
                    type: CUSTOMER_PAGINATION,
                    payload: result?.pagination || {},
                });

                return result?.data || [];
            }

            throw new Error("Failed to fetch Customers");
        } catch (error) {
            throw error;
        }
    };
};

export const createCustomer = (payload) => {
    return (dispatch) => {
        try {
            dispatch(callLoader(true));
            const url = `v1/CustomerProfile/InsertCustomerInfo`;
            return APICall("post", payload, url).then(
                (result) => {
                    dispatch(callLoader(false));
                    if (result?.statuscode === 200 || result?.statuscode === 201) {
                        return result;
                    } else {
                        return Promise.reject(result);
                    }
                },
                (error) => {
                    dispatch(callLoader(false));
                    return Promise.reject(error);
                },
            );
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);
        } finally {
            dispatch(callLoader(false));
        }
    };
};

export const updateCustomer = (payload) => {
    return (dispatch) => {
        try {
            dispatch(callLoader(true));

            const url = `v1/CustomerProfile/UpdateCustomerInfo`;

            return APICall("post", payload, url).then(
                (result) => {
                    dispatch(callLoader(false));

                    if (
                        result?.statuscode === 200 ||
                        result?.statuscode === 201
                    ) {
                        return result;
                    }

                    return Promise.reject(result);
                },
                (error) => {
                    dispatch(callLoader(false));
                    return Promise.reject(error);
                }
            );
        } catch (error) {
            console.error("Update customer error:", error);
            dispatch(callLoader(false));
            return Promise.reject(error);
        }
    };
};

export const getCustomerCompanyList = (companyId) => {
    return async (dispatch) => {
        try {
            const queryParams = new URLSearchParams({
                CompanyId: companyId,
            }).toString();

            const url = `/GetCustCompanyList?${queryParams}`;

            const result = await APICall("get", null, url);

            if (
                result?.statuscode === 200 ||
                result?.statuscode === 201
            ) {
                dispatch({
                    type: CUSTOMER_COMPANY_LIST,
                    payload: result?.data || [],
                });

                return result?.data || [];
            }

            throw new Error(
                result?.message || "Failed to fetch customer company list"
            );
        } catch (error) {
            console.error("Get customer company list error:", error);
            throw error;
        }
    };
};
